module.exports = __webpack_public_path__ + "img/xczp.6145b0f9.png";